<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">

      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="username">
            <a-input v-model="form.username" class="search-input" placeholder="请输入账号"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="name">
            <a-input v-model="form.name" class="search-input" placeholder="请输入姓名"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="mobile">
            <a-input v-model="form.mobile" class="search-input" placeholder="请输入手机号"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
        <div class="right-option-box">
          <a-button class="option-btn" type="primary" @click="handleModalVisible('showAddModal',true,1)">添加</a-button>
        </div>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
          <template slot="action" slot-scope="text,record">
            <a-button type="link" @click="handleModalVisible('showAddModal',true,2,record)">编辑</a-button>
            <a-button type="link" @click="handleModalVisible('showPasswordModal',true,null,record)">重置密码</a-button>
            <a-button type="link" @click="handleModalVisible('showDeleteModal',true,null,record)">删除</a-button>
          </template>
        </a-table>
        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>

    </div>
    <CommonModal v-model="showAddModal" :title="modalFlag == 1 ? '添加用户' : '编辑用户'" width="400px" @confirm="handleAddConfirm">
      <div class="a-form-style search-all-box">
        <a-form :form="addForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-form-item label="账号：">
            <a-input class="search-input" v-decorator="addRules.username" @blur="changeUserSearch" :disabled="modalFlag == 2" />
          </a-form-item>
          <a-form-item label="密码" v-if="modalFlag == 1">
            <div class="random-password">
              <div class="password">随机密码为：<span>{{ password }}</span></div>
              <div class="copy" @click="copyPassword(password)">复制密码</div>
            </div>
          </a-form-item>
          <a-form-item label="姓名">
            <a-input class="search-input" v-decorator="addRules.name" />
          </a-form-item>
          <a-form-item label="手机号">
            <a-input class="search-input" v-decorator="addRules.mobile" />
          </a-form-item>
        </a-form>
      </div>
    </CommonModal>
    <CommonModal v-model="showDeleteModal" title="删除用户" confirmText="确定" @confirm="handleDeleteConfirm">
      <div class="delete-modal">
        确定删除用户吗？
      </div>
    </CommonModal>
    <CommonModal v-model="showPasswordModal" title="重置密码" :showCancel="!passwordReset" confirmText="确定" @cancel="handlePasswordCancel" @confirm="handlePasswordConfirm">
      <div class="delete-modal">
        <div class="random-password" v-if="passwordReset">
          <div class="password">已重置密码为：<span>{{ password }}</span></div>
          <div class="copy" @click="copyPassword(password)">复制密码</div>
        </div>

        <p v-else>
          确定要重置密码吗？
        </p>

      </div>
    </CommonModal>
  </div>
</template>
<script>
import Bread from "../../../../components/school/Bread.vue";
import CommonModal from "../../../../components/CommonModal"
import utils from "../../../../assets/js/utils"
import services from "../../../../assets/js/services"
import { mapActions } from "vuex";
export default {
  components: {
    Bread,
    CommonModal
  },
  data () {
    return {
      services,
      breadConfig: [{ name: "系统管理" }, { name: "管理员管理" }],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        name: "",
        username: '',
        mobile: '',
      },
      addForm: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
        {
          title: "添加时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      showAddModal: false,
      showDeleteModal: false,
      showPasswordModal: false,
      passwordReset: false,
      addRules: {
        username: ['username', {
          validateTrigger: 'blur',
          rules: [
            { required: true, whitespace: true, message: '请输入账号' },
            { validator: this.checkUserName },
          ]
        }],
        name: ['name', {
          validateTrigger: 'blur',
          rules: [
            { required: true, whitespace: true, message: '请输入姓名' },
            {
              max: 50,
              whitespace: true,
              message: "姓名最长不能超过50字符",
            }
          ]
        }],
        mobile: ['mobile', {
          validateTrigger: "blur",
          initialValue: '',
          rules: [
            { validator: this.checkMobile, }
          ]
        }],
      },
      password: "",
      modalFlag: 1,// 1添加 2编辑
      rowKey: null,//选中的用户
      userExistId: '', // 添加用户时，判断账号是否存在 有id表示存在
    };
  },
  watch: {
    showAddModal (val) {
      let that = this
      if (val) {
        that.$nextTick(() => {
          that.addForm.resetFields();
        });
      }
    },
  },
  beforeCreate() {
    this.addForm = this.$form.createForm(this);
  },
  mounted () {
    // this.handleModalVisible("showAddModal", true)
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolManageUser", "addSchoolManageUser", "editSchoolManageUser", "getSchoolManageUserInfo", "getSchoolManageUserSearch"]),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        role_ids: 1, // 1老师 2管理员
        username: this.form.username,
        name: this.form.name,
        mobile: this.form.mobile,
      };
      this.getSchoolManageUser(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },

    // 校验手机号
    checkMobile (rule, value, callback) {
      const reg = /^1[0-9]{10}$/

      if (rule && value) {
        if (reg.test(value)) {
          return callback();
        } else {
          return callback(new Error('请填写正确的手机号'));
        }
      }
      else {
        return callback();
      }
    },
    // 校验账号
    checkUserName (rule, value, callback) {
      const reg = /^[a-zA-Z0-9_]{6,16}$/;
      if (rule && value) {
        if (reg.test(value)) {
          return callback();
        } else {
          return callback(new Error('请输入【6-16】位，由数字或字母组成的账号'));
        }
      }
      else {
        return callback();
      }
    },
    // 复制随机密码
    copyPassword (context) {
      let inputElement = document.createElement('input')
      inputElement.value = context
      document.body.appendChild(inputElement)
      inputElement.select()
      document.execCommand('Copy')
      inputElement.remove()
      this.$message.success("复制成功")
    },
    // 添加账号时查询方法
    changeUserSearch(e){
      let that = this
      if(e.target.value){
        that.getSchoolManageUserSearch({
          username: e.target.value,
        }).then(res => {
          if(res.code == '0000'){
            if(res.data){
              that.userExistId = res.data.id 
              that.addForm.setFieldsValue({
                username: res.data.username,
                name: res.data.name,
                mobile: res.data.mobile,
              })
            }
          } else {
            this.userExistId = ''
            that.addForm.setFields({
              username: {
                value: e.target.value,
                errors: [new Error(`${res.message}`)]
              }
            })
          }
        })
      }
    },
    // 获取当前编辑用户的信息
    userDetails(id){
      let that = this
      this.getSchoolManageUserInfo({id: id}).then(res => {     
        if(res.code == '0000'){
          that.$nextTick(() => {
            setTimeout(() => {
              that.addForm.setFieldsValue({
                username: res.data.username,
                name: res.data.name,
                mobile: res.data.mobile,
              })
            }, 200);
          })
        }
      })
    },
    // 点击添加编辑、删除、重置密码 弹窗展开方法
    handleModalVisible (key, val, flag, rowKey) {
      let that = this
      that[key] = val
      that.rowKey = rowKey
      if (key == 'showAddModal' && val) {
        that.modalFlag = flag
        if (flag == 1) {
          that.password = utils.randomPassword()
        } else if( flag == 2) {
          that.userDetails(rowKey.id)
        }
      }
    },
    // 添加、编辑用户方法
    async requestUserOperate (type, params) {
      let that = this
      await services[type == 1 ? "addSchoolManageUser" : "editSchoolManageUser"](params).then(res => {
        if (res.code == "0000") {
          that.$message.success(`${type == 1 ? '添加' : type == 2 ?'编辑': '删除'}成功`)
          that.getTableList()
        } else {
          that.$message.error(res.message)
        }
      })
    },
    // 编辑添加用户 提交表单事件
    handleAddConfirm () {
      let that = this
      this.addForm.validateFields((err, values) => {
        if (!err) {
          if (that.modalFlag == 1) {
            let data = { ...values, password: this.password, role_ids: 1 }
            if(that.userExistId) data.id = that.userExistId
            that.requestUserOperate(that.modalFlag, data)
          } else {
            console.log("编辑",  {id:that.rowKey, data: { ...values, _method:'put'} });
            that.requestUserOperate(that.modalFlag, {id: that.rowKey.id, data: { ...values, _method:'put'} })
          }

          that.handleModalVisible("showAddModal", false)
        }
      });
    },
    // 确认删除
    async handleDeleteConfirm () {
      await this.requestUserOperate(3, {id: this.rowKey.id, data: { _method:'delete'} })
      this.handleModalVisible("showDeleteModal", false)
    },
    // 确认重置密码
    handlePasswordConfirm () {
      let that = this
      if (that.passwordReset) {
        that.handleModalVisible("showPasswordModal", false)
        that.handlePasswordCancel()
      } else {
        services.resetSchoolStudentPassword({id: that.rowKey.id, _method: 'put'}).then(res => {
          if (res.code == "0000") {
            that.password = res.data
            that.passwordReset = true
            that.$message.success(`重置密码成功`)
          } else {
            that.$message.error(res.message)
          }
        })
      }
    },
    handlePasswordCancel () {
      let that = this
      let timer = setTimeout(function () {
        that.passwordReset = false
        that.password = ''
        clearTimeout(timer)
      }, 500)
    },
  },
};
</script>

<style lang="less" scoped>
.a-form-style {
    .ant-form {
        width: 100%;
    }
    .ant-form-item {
        margin-bottom: 10px;
    }
}
</style>